<!--封装地图控件，集成多加地图-->
<template>
  <div :id="mapId" style="height: 100%; width: 100%">
    <!--地图-->
  </div>
</template>
<script>
import { mapState } from "vuex";
import { BaiduMap } from "./maps/BaiduMap.js";
import { GoogleMap } from "./maps/GoogleMap.js";
import { AMapMap } from "./maps/AMapMap.js";

export default {
  name: "KingLongMap",
  props: {
    mapId: {
      type: String,
      default: "kinglongMap",
    },
    coordsType: {
      type: Number,
      default: 5,//3 wgs84 5 gc_02 9  bd_09
    },
  },
  data() {
    return {
      map: undefined,
      markerClusterer: "",
      zoom: 12,
      markerArr: [],
      overlayArr: [],
      visibilityState: "visible",
      intervalFlag: "",
      trafficCtrl: "",
      myDistanceToolObject: "",
    };
  },
  computed: {
    ...mapState({
      mapConfig: (state) => {
        if (state.user.operator.Latitude && state.user.operator.Longitude) {
          console.log({
            mapCenter: state.user.operator.Longitude + "," + state.user.operator.Latitude,
            mapZoom: 15
          })
          return {
            mapCenter: state.user.operator.Longitude + "," + state.user.operator.Latitude,
            mapZoom: 15
          }
        }
        return state.user.mapConfig;
      },
    }),
  },

  mounted() {
    var t = this;
    setTimeout(() => {
      this.initMap();
    }, 1000);
    document.onvisibilitychange = function () {
      window.clearInterval(t.intervalFlag),
        (t.intervalFlag = ""),
        (t.visibilityState = document.visibilityState);
    };
  },
  methods: {
    removeClustererById(id) {
      if (this.map) {
        this.map.removeClustererById(id)
      }
    },

    addMarkerToCluster(id, title, lon, lat, icon, callback) {
      // console.log('addMarkerToCluster-', id, title, lon, lat, icon, callback)
      if (this.map) this.map.addMarkerToCluster(id, title, lon, lat, icon, callback);
    },
    addMarkersToCluster(markersData) {
      if (this.map) this.map.addMarkersToCluster(markersData);
    },
    clearMarkerCluster() {
      if (this.map) this.map.clearMarkerCluster();
    },
    showCluster() {
      if (this.map) this.map.showCluster();
    },
    initMap() {

      //海外用户去接口获取本月已经使用的谷歌地图次数，如果超过1000次，直接使用百度地图
      // 
      // console.log(this.$store.getters.operator.GoogleMapInfo)
      if (this.$store.getters.operator.IsForeign == 1 && this.$store.getters.mapType === 'google') {
        //当前的谷歌地图调用次数，是否超过了限制次数
        if (this.$store.getters.operator.GoogleMapInfo.Used >= this.$store.getters.operator.GoogleMapInfo.Limit) {
          this.$store.commit("app/changeMapType", "baidu");
        } else {
          //调用谷歌地图接口
          this.$api.useGoogleMap({
          }).then(res => {
            if (res.code == 200) {
              this.$store.dispatch("user/setGoogleMapInfo", res.data[0]);
            }
          }).catch(err => {
            this.$store.commit("app/changeMapType", "baidu");
          })
        }

      }

      // console.log("目前使用地图类型", this.$store.getters.mapType);

      this.map = new (this.$store.getters.mapType === 'google' ? GoogleMap : this.$store.getters.mapType === 'baidu' ? BaiduMap : AMapMap)(); // new BaiduMap(); new GoogleMap();
      //  this.map = new BaiduMap();

      this.map.initMap(this.mapId, {
        coordsType: this.coordsType,//BMAP_COORD_GCJ02 
        center: this.mapConfig && this.mapConfig.mapCenter
          ? this.mapConfig.mapCenter.split(",")
          : undefined,
        zoom: this.mapConfig && this.mapConfig.mapZoom ? this.mapConfig.mapZoom : this.zoom,
        completed: () => {
          this.$emit("LoadCompleted");
        },
      });
    },

    DrawRectangleCompleted(left_lng, left_lat, right_lng, right_lat) {
      this.$emit(
        "DrawRectangleCompleted",
        left_lng,
        left_lat,
        right_lng,
        right_lat
      );
    },
    DrawPolygonCompleted(lnglats) {
      this.$emit("DrawPolygonCompleted", lnglats);
    },
    DrawCircleCompleted(lng, lat, radius) {
      this.$emit("DrawCircleCompleted", lng, lat, radius);
    },
    DrawPolyLineCompleted(lnglats) {
      this.$emit("DrawPolyLineCompleted", lnglats);
    },
    DrawPointCompleted(lng, lat) {
      this.$emit("DrawPointCompleted", lng, lat);
    },

    setCenter(lng, lat) {
      if (this.map) this.map.setCenter(lng, lat);
    },

    cancelDraw() {
      if (this.map) this.map.cancelDraw();
    },
    drawRectangle(width, color, fillColor, callback) {
      if (this.map)
        this.map.drawRectangle(
          width,
          color,
          fillColor,
          callback || this.DrawRectangleCompleted
        );
    },
    drawPolygon(width, color, fillColor) {
      if (this.map)
        this.map.drawPolygon(
          width,
          color,
          fillColor,
          this.DrawPolygonCompleted
        );
    },
    drawCircle(width, color, fillColor) {
      if (this.map)
        this.map.drawCircle(width, color, fillColor, this.DrawCircleCompleted);
    },
    drawLine(width, color) {
      if (this.map) this.map.drawLine(width, color, this.DrawPolyLineCompleted);
    },
    drawPoint() {
      if (this.map) this.map.drawPoint(this.DrawPointCompleted);
    },
    clearAll() {
      if (this.map) this.map.clearAll();
    },
    clearMarkers() {
      if (this.map) this.map.clearMarkers();
    },
    removeMarkerById(id) {
      if (this.map) this.map.removeMarkerById(id);
    },

    removePolylineById(id) {
      if (this.map) this.map.removePolylineById(id);
    },
    addMarker(id, name, lng, lat, iconUrl, callback, iconWidth, iconHeight, options) {
      if (this.map) this.map.addMarker(id, name, lng, lat, iconUrl, callback, iconWidth, iconHeight, options);
    },
    removePolygonById(id) {
      if (this.map) this.map.removePolygonById(id);
    },
    removeCircleById(id) {
      if (this.map) this.map.removeCircleById(id);
    },
    addPolygon(id, name, coordanites, strokeWidth, strokeColor, fillColor, isReCenter = true) {

      if (this.map)
        this.map.addPolygon(
          id,
          name,
          coordanites,
          strokeWidth,
          strokeColor,
          fillColor,
          isReCenter
        );
    },
    addPolyline(id, name, coordanites, strokeWidth, strokeColor, isArrow, isReCenter = true) {
      if (this.map)
        this.map.addPolyline(id, name, coordanites, strokeWidth, strokeColor, isArrow, isReCenter);
    },

    /** 把视野缩放到给定点集（不清除覆盖物）。底图不支持时静默忽略 */
    fitBounds(points, margin) {
      if (this.map && this.map.fitBounds) this.map.fitBounds(points, margin);
    },
    /** 开启点击地图拾取坐标（不清除覆盖物）。底图不支持时返回 false */
    enablePickPoint(callback, once) {
      if (this.map && this.map.enablePickPoint) {
        this.map.enablePickPoint(callback, once);
        return true;
      }
      return false;
    },
    disablePickPoint() {
      if (this.map && this.map.disablePickPoint) this.map.disablePickPoint();
    },
    /**
     * 取底层原生地图实例（目前仅百度底图实现）。
     * 用于需要精细控制的场景（如线路编辑的可拖拽顶点手柄），
     * 调用方必须判空并准备好降级方案。
     */
    getRawMap() {
      return this.map && this.map.getRawMap ? this.map.getRawMap() : null;
    },

    addCircle(id, lnglat, radius, strokeWidth, strokeColor, fillColor, isReCenter = true) {
      if (this.map)
        this.map.addCircle(
          id,
          lnglat,
          radius,
          strokeWidth,
          strokeColor,
          fillColor,
          isReCenter
        );
    },

    centerAndZoom(lng, lat, zoom) {
      if (this.map) this.map.centerAndZoom(new BMap.Point(lng, lat), zoom);
    },
    setCenter(lng, lat) {
      if (this.map) this.map.setCenter(lng, lat);
    },


    setViewport(view) {
      if (this.map) this.map.setViewport(view);
    },
    removeOverlay(overlay) {
      if (this.map) this.map.removeOverlay(overlay);
    },
    clearOverlay() {
      if (this.map) this.map.clearAll();
    },
    addOverlay(overlay) {
      if (this.map) this.map.addOverlay(overlay);
    },
    openInfoWindow(infoWindow, point) {
      if (this.map) this.map.openInfoWindow(infoWindow, point);
    },
    pointToLineDist(x1, y1, x2, y2, x0, y0) {
      if (this.map) return this.map.pointToLineDist(x1, y1, x2, y2, x0, y0);
    },
  },
};
</script>
